import React, { Fragment } from 'react';
import Form from '../../form';

const IntervuDetails = () => {

  return (
    <Fragment>
      <Form.FieldGroup label="End client company ID*">
        <Form.Input
          name="intervu.clientCompany.sfCompanyId"
          placeholder="Type End client company SalesForce ID" />
        <Form.FieldError name="intervu.clientCompany.sfCompanyId" />
      </Form.FieldGroup>

      <Form.FieldGroup label="End client company name*">
        <Form.Input
          name="intervu.clientCompany.name"
          placeholder="Type End client company name" />
        <Form.FieldError name="intervu.clientCompany.name" />
      </Form.FieldGroup>

      <Form.FieldGroup label="End client ID*">
        <Form.Input
          name="intervu.clientContact.sfContactId"
          placeholder="Type End client SalesForce ID" />
        <Form.FieldError name="intervu.clientContact.sfContactId" />
      </Form.FieldGroup>

      <Form.FieldGroup label="End client name*">
        <Form.Input
          name="intervu.clientContact.name"
          placeholder="Type End client name" />
        <Form.FieldError name="intervu.clientContact.name" />
      </Form.FieldGroup>

      <Form.FieldGroup label="End client email*">
        <Form.Input
          name="intervu.clientContact.email"
          type="email"
          placeholder="Type End client email" />
        <Form.FieldError name="intervu.clientContact.email" />
      </Form.FieldGroup>

      <Form.FieldGroup label="End client phone*">
        <Form.Input
          name="intervu.clientContact.phone"
          placeholder="Type End client phone" />
        <Form.FieldError name="intervu.clientContact.phone" />
      </Form.FieldGroup>

      <Form.FieldGroup label="Countries">
        <Form.CountrySelect
          name="countries" />
      </Form.FieldGroup>

      <Form.FieldGroup label="Two channel audio">
        <Form.Input
          name="intervu.twoChannelAudio"
          type="checkbox" />
      </Form.FieldGroup>

      <Form.FieldGroup label="Video Insights">
        <Form.Input
          name="intervu.videoInsights"
          type="checkbox" />
      </Form.FieldGroup>

      <Form.FieldGroup label="Launch date*" className="right to-right">
        <Form.Datepicker
          name="launchDate" />
        <Form.FieldError name="launchDate" />
      </Form.FieldGroup>

    </Fragment>
  );
}

export default IntervuDetails;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectForm/IntervuDetails.js